var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThoughtful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2785_491)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#9D42FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.666 17.1667C13.666 17.3507 13.5167 17.5 13.3327 17.5H10.666C10.482 17.5 10.3327 17.3507 10.3327 17.1667C10.3327 16.9826 10.482 16.8333 10.666 16.8333H13.3327C13.5167 16.8333 13.666 16.9827 13.666 17.1667ZM13.3327 17.6667H10.666C10.4467 17.6667 10.2768 17.8785 10.3499 18.1087C10.3939 18.2475 10.5343 18.3333 10.68 18.3333H10.685C10.8775 18.3333 11.0535 18.4422 11.1397 18.6143L11.1432 18.6213C11.2594 18.8533 11.4965 19 11.756 19H12.2427C12.5022 19 12.7394 18.8533 12.8554 18.6213L12.8589 18.6143C12.9451 18.4422 13.121 18.3333 13.3135 18.3333H13.3185C13.4642 18.3333 13.6047 18.2475 13.6487 18.1087C13.7218 17.8785 13.552 17.6667 13.3327 17.6667ZM11.9994 7C12.1834 7 12.3327 6.85066 12.3327 6.66667V5.33333C12.3327 5.14934 12.1834 5 11.9994 5C11.8154 5 11.666 5.14934 11.666 5.33333V6.66667C11.666 6.85066 11.8154 7 11.9994 7ZM8.46386 8.26917C8.52886 8.33434 8.6142 8.36684 8.69952 8.36684C8.78486 8.36684 8.87018 8.33434 8.93518 8.26917C9.06535 8.139 9.06535 7.92799 8.93518 7.79784L7.99236 6.855C7.86236 6.72483 7.65102 6.72483 7.52104 6.855C7.39087 6.98517 7.39087 7.19615 7.52104 7.32632L8.46386 8.26917ZM7.66602 11.3333C7.66602 11.1493 7.51668 11 7.33268 11H5.99935C5.81535 11 5.66602 11.1493 5.66602 11.3333C5.66602 11.5173 5.81535 11.6667 5.99935 11.6667H7.33268C7.5167 11.6667 7.66602 11.5173 7.66602 11.3333ZM8.46386 14.3975L7.52104 15.3403C7.39087 15.4705 7.39087 15.6815 7.52104 15.8117C7.58604 15.8768 7.67136 15.9093 7.7567 15.9093C7.84202 15.9093 7.92736 15.8768 7.99236 15.8117L8.93518 14.8688C9.06535 14.7387 9.06535 14.5277 8.93518 14.3975C8.80518 14.2673 8.59386 14.2673 8.46386 14.3975ZM15.5349 14.3975C15.4047 14.2673 15.1937 14.2673 15.0635 14.3975C14.9334 14.5277 14.9334 14.7387 15.0635 14.8688L16.0064 15.8117C16.0715 15.8768 16.1567 15.9093 16.242 15.9093C16.3274 15.9093 16.4125 15.8768 16.4777 15.8117C16.6079 15.6815 16.6079 15.4705 16.4777 15.3403L15.5349 14.3975ZM17.9993 11H16.666C16.482 11 16.3327 11.1493 16.3327 11.3333C16.3327 11.5173 16.482 11.6667 16.666 11.6667H17.9993C18.1833 11.6667 18.3327 11.5173 18.3327 11.3333C18.3327 11.1493 18.1833 11 17.9993 11ZM15.2992 8.36684C15.3845 8.36684 15.4697 8.33434 15.5348 8.26917L16.4777 7.32632C16.6079 7.19615 16.6079 6.98517 16.4777 6.855C16.3475 6.72483 16.1365 6.72483 16.0064 6.855L15.0635 7.79784C14.9333 7.92801 14.9333 8.139 15.0635 8.26917C15.1285 8.33434 15.2139 8.36684 15.2992 8.36684ZM13.666 16.3333C13.666 16.5173 13.5167 16.6667 13.3327 16.6667H10.666C10.482 16.6667 10.3327 16.5173 10.3327 16.3333C10.3327 16.1558 10.4718 16.012 10.6468 16.002C10.4393 14.1263 8.49935 13.7085 8.49935 11.5C8.49935 9.56701 10.0664 8 11.9993 8C13.9323 8 15.4993 9.56701 15.4993 11.5C15.4993 13.7085 13.5593 14.1263 13.3518 16.002C13.5268 16.012 13.666 16.1558 13.666 16.3333ZM11.2312 8.935C11.1793 8.80716 11.0339 8.74566 10.9055 8.79716C10.0537 9.14233 9.40788 9.88015 9.17803 10.7708C9.14352 10.9046 9.22403 11.0408 9.35771 11.0753C9.37854 11.0808 9.39955 11.0833 9.42021 11.0833C9.53153 11.0833 9.63305 11.0085 9.66222 10.8958C9.85256 10.1578 10.3876 9.54647 11.0932 9.26064C11.2212 9.20885 11.2829 9.06316 11.2312 8.935Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2785_491",
    x: 0,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2785_491"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtful);
export default __webpack_public_path__ + "static/media/Thoughtful.c98a283ab514e715276dc1a5b0ced7cf.svg";
export { ForwardRef as ReactComponent };